<script setup>
import useManageTable from "./hooks/useManageTable";
import useManageEdit from "./hooks/useManageEdit";
import useCateGoryList from "../../hooks/useCategoryList";
import Adjust from "./adjust.vue";
import { importMateriel } from "@/api/materiel";
import FileUpload from "@/components/FileUpload.vue";
import { onMounted } from "vue";

const {
  searchData,
  searchRef,
  columns,
  tableData,
  tableLoading,
  pageParams,
  brandList,
  modelList,
  uploadConfig,
  uploadRef,
  getList,
  handleReset,
  handleUpload,
  handleDownload,
  getDictList,
} = useManageTable();

const { editRef, handleEdit, handleDelete } = useManageEdit(getList);

const { categoryList } = useCateGoryList();

onMounted(() => {
  getList();
  getDictList();
});
</script>

<template>
  <div class="page-container">
    <div class="layout-header">
      <div>物料管理</div>
      <div>
        <!-- 按钮 -->
        <el-button type="primary" icon="Plus" @click="handleEdit(null, true)"
          >新增</el-button
        >
      </div>
    </div>
    <div class="main-pane">
      <!-- 搜索栏 -->
      <el-form :model="searchData" ref="searchRef" label-width="90">
        <el-row :gutter="10">
          <el-col :xl="5" :sm="6">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="searchData.name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :xl="5" :sm="6">
            <el-form-item label="编号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :xl="5" :sm="6">
            <el-form-item label="类别：" prop="categoryId">
              <el-select
                v-model="searchData.categoryId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :sm="6">
            <el-form-item label="品牌：" prop="brand">
              <el-select
                v-model="searchData.brand"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :sm="0" />
          <el-col :xl="5" :sm="6">
            <el-form-item label="规格型号：" prop="model">
              <el-select
                v-model="searchData.model"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in modelList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :sm="8">
            <el-form-item label="创建时间：" prop="createTime">
              <el-date-picker
                v-model="searchData.createTime"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button icon="Upload" @click="handleUpload()">导入</el-button>
          <el-button icon="Download" @click="handleDownload()">导出</el-button>
          <el-button type="primary" icon="Search" @click="getList()"
            >查询</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="120"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleEdit(row, false)"
              >编辑</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pageParams.total"
        v-model:current-page="pageParams.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
        class="mt10"
      />
    </div>
    <!-- 编辑组件 -->
    <Adjust ref="editRef" @afterSave="getList" />

    <!-- 导入组件 -->
    <FileUpload
      ref="uploadRef"
      @afterUpload="getList"
      :fn="importMateriel"
      :uploadConfig="uploadConfig"
    />
  </div>
</template>

<style scoped></style>
